module.exports = __webpack_public_path__ + "cl_illy_empty.c2e186ab9544c677d71917df3e64fce4.svg";